module.exports = __webpack_public_path__ + "img/01.77de0c69.jpg";